import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class TranslationLoaderService {
  constructor(private translate: TranslateService) {}

  loadTranslations(): Promise<void> {
    return new Promise((resolve) => {
      const lang = this.translate.getBrowserLang() || 'en'; // Fallback to 'en' if no browser language found
      this.translate.use(lang).subscribe(() => {
        resolve();
      });
    });
  }
}
